<div class="login-container container-fluid" *ngIf="currentScreenFlow === CreateAccountFlow.lookupUserSetup">
  <app-lookup-user (lookupUserResponse)="lookupUserResponse($event)"></app-lookup-user>
</div>
<!-- Success step-->
<div class="account-parent" *ngIf="currentScreenFlow === CreateAccountFlow.successStep">
  <app-success-step [contactInfo]="contactInfo"></app-success-step>
</div>
<div class="account-parent" *ngIf="currentScreenFlow != CreateAccountFlow.lookupUserSetup && currentScreenFlow != CreateAccountFlow.successStep">
  <div class="back-step">
    <a href="javascript:void(0)" (click)="previousScreen()">
      <adp-label labelKey="Signup_Create_Account_BackStep_Text"></adp-label>
    </a>
  </div>
  <div class="account-setup">
    <div class="step-text"></div>
    <div class="col-12" [ngClass]="{'verification-title': currentScreenFlow === CreateAccountFlow.securitySetup}">
      <div class="header-text heading">{{heading}}</div>
    </div>

    <!-- Security step -->
    <div *ngIf="currentScreenFlow === CreateAccountFlow.securitySetup">
      <app-security-verification [lookupResponse]="lookupResponse"
        [contactInfo]="contactInfo"
        [isReviewContactFinished]="isReviewContactFinished"
        [isSecondaryOTPNeeded]="isSecondaryOTPNeeded"
        (createOTPResponse)="createOTPResponse($event)">
      </app-security-verification>
    </div>

    <!-- OTP step -->
    <div *ngIf="currentScreenFlow === CreateAccountFlow.otpSetup">
      <app-verify-otp [otpRequest]="otpRequest"
        [lookupResponse]="lookupResponse" [isSecondaryOTPNeeded]="isSecondaryOTPNeeded"
        [isReviewContactFinished]="isReviewContactFinished"
        (verifyOTPResponse)="verifyOTPResponse($event)">
      </app-verify-otp>
    </div>

    <!-- Contact review step-->
    <div *ngIf="currentScreenFlow === CreateAccountFlow.reviewContactSetup && !isReviewContactDisabled">
      <app-review-contact [contactInfo]="contactInfo" [lookupResponse]="lookupResponse"
        (reviewContactResponse)="reviewContactResponse($event)">
      </app-review-contact>
    </div>

    <!-- Contact Setup step-->
    <div *ngIf="currentScreenFlow === CreateAccountFlow.contactSetup">
      <app-contact-setup [contactInfo]="contactInfo"
        [primaryEmail]="this.decryptedCCDetails.primaryEmail"
        (submitted)="contactInfoSubmitted($event)"></app-contact-setup>
    </div>

    <!-- Address review step-->
    <div *ngIf="currentScreenFlow === CreateAccountFlow.reviewAddressSetup && !skipReviewAddressStep">
      <app-review-address [contactInfo]="decryptedCCDetails"
        (reviewAddressResponse)="reviewAddressResponse($event)">
      </app-review-address>
    </div>

    <!-- Create password step -->
    <div class="password-container">
      <form [formGroup]='passwordForm' (ngSubmit)='signUp()' class="mt-32"
        *ngIf="currentScreenFlow === CreateAccountFlow.passwordSetup" fxLayout='column' fxLayoutAlign='start stretch'>
        <pgh-password-form [forFormGroup]="passwordForm" [passwordLabelSFKey]="'PasswordForm_PasswordField_Label'" [confirmPasswordLabelSFKey]="'PasswordForm_ConfirmPasswordField_Label'"></pgh-password-form>

        <div class="mt-32">
          <button mat-flat-button color='accent' type="submit" [disabled]='passwordForm.invalid || signUpInProgress'>
            <adp-label labelKey="PasswordForm_Submit_Button_Text"></adp-label>
            <mat-spinner class='sign-up-progress-indicator' diameter='20' *ngIf='signUpInProgress'></mat-spinner>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
